(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["videobackground"] && !window.DesignMode) return;
  try {
    

var poster = $('.video').data("poster");
var video = $('.video').data("video");
$(".video").background({
    source:
    {
        poster: poster,
        mp4: video
    },loop:true
});


  } catch(e) { console.error(e); }
})();

})();
